module.exports = __webpack_public_path__ + "img/facebook.81929db6.svg";